import TextareaAutosize from '@mui/material/TextareaAutosize';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/TextareaAutosize": TextareaAutosize } } });
export default ClientProvider;
